import React, { useState, useEffect } from "react";
import Footer from "./Footer";
// Header import File
// import BannerImg from "../assests/bannerImg.jpg";
import QuotesBanner from "../assests/quotesBanner.jpg";
import prelorder from "../assests/loadingIcon.png";
import Logo from "../assests/mediLogo.png";
import { Link, NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay } from "swiper/modules";
import axios from "axios";
import { baseUrl } from "./Api/BaseUrl";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaGooglePlusG,
  FaYoutube,
} from "react-icons/fa";
// Header import File

// Localization data
const headerTranslations = {
  1: {
    news: "News",
    agency: "Agency",
    services: "Services",
    work: "Work",
    team: "Team",
    contact: "Contact Us",
    ourteam: "Our Team",
    ourservices: "Our Services",
    email: "Email",
    address: "Address",
    quotes: "Ask for a Quotes",
    quotestext:
      "Please fill out this form to receive a tailor-made quote. A member of our team will contact you quickly.",
    enterfirstname: "Enter first name*",
    enterlastname: "Enter last name*",
    entercompanyname: "Enter company name*",
    enteremailname: "Enter Email address*",
    enterphonenumber: "Enter phone number*",
    entersector: "Enter your sector*",
    entermediatype: "Enter media type*",
    enterproduct: "Enter your product*",
    enterdate: "Enter your date*",
    enterformat: "Enter your format*",
    entersupport: "Enter your support*",
    enterquantity: "Enter your quantity*",
    entermessage: "Enter your message*",
    send: "Send",
    sending: "Sending",
  },
  2: {
    news: "Nouvelles",
    agency: "Agence",
    services: "Services",
    work: "Travail",
    team: "Équipe",
    contact: "Contactez",
    ourteam: "Notre équipe",
    email: "e-mail",
    address: "Adresse",
    ourservices: "Nos prestations",
    quotes: "Demandez un devis",
    quotestext:
      "Merci de remplir ce formulaire pour recevoir un devis sur mesure. Un membre de notre équipe vous contactera rapidement.",
    enterfirstname: "Entrez le prénom*",
    enterlastname: "Entrez le nom de famille*",
    entercompanyname: "Entrez le nom de l'entreprise*",
    enteremailname: "Entrez l'adresse e-mail*",
    enterphonenumber: "Entrez le numéro de téléphone*",
    entersector: "Entrez votre secteur*",
    entermediatype: "Entrez le type de média*",
    enterproduct: "Entrez votre produit*",
    enterdate: "Entrez votre date*",
    enterformat: "Entrez votre format*",
    entersupport: "Entrez votre soutien*",
    enterquantity: "Entrez votre quantité*",
    entermessage: "Entrez votre message*",
    send: "Envoyer",
    sending: "Envoi...",
  },
  3: {
    news: "الأخبار",
    agency: "وكالة",
    services: "الخدمات",
    work: "العمل",
    team: "الفريق",
    contact: "اتصل بنا",
    ourteam: "فريقنا",
    email: "بريد إلكتروني",
    address: "عنوان",
    ourservices: "خدماتنا",
    quotes: "اسأل عن الأسعار",
    quotestext:
      "يرجى ملء هذا النموذج للحصول على عرض أسعار مخصص. سيقوم أحد أعضاء فريقنا بالاتصال بك بسرعة.",
    enterfirstname: "أدخل الاسم الأول*",
    enterlastname: "أدخل الاسم الأخير*",
    entercompanyname: "أدخل اسم الشركة*",
    enteremailname: "أدخل عنوان البريد الإلكتروني*",
    enterphonenumber: "أدخل رقم الهاتف*",
    entersector: "أدخل قطاعك*",
    entermediatype: "أدخل نوع الوسائط*",
    enterproduct: "أدخل منتجك*",
    enterdate: "أدخل تاريخك*",
    enterformat: "أدخل التنسيق الخاص بك*",
    entersupport: "أدخل دعمك*",
    enterquantity: "أدخل الكمية الخاصة بك*",
    entermessage: "أدخل رسالتك*",
    send: "يرسل",
    sending: "إرسال...",
  },
};
const QuoteForm = () => {
  // ------- Header Import Code-------
  const [isActive, setIsActive] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const [Active, setActive] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [language, setLanguage] = useState(1);
  const [footerData, setFooterData] = useState(null);

  // Search toggle
  const toggleSearch = () => {
    setIsSearchOpen((prev) => !prev);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const searchQuery = e.target.elements.q.value;
    console.log("Search query:", searchQuery);
  };

  // Toggle menu on mobile
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // ToogleControl Method
  const handleToggleClick = () => {
    if (Active) {
      setIsOverflow(!isOverflow);
      setActive(false);
      // Adding transition delays when removing 'active'
      setTimeout(() => {
        document.querySelector(".all-cases").style.transitionDelay = "0.5s";
        document.querySelector(".all-cases .layer").style.transitionDelay =
          "0.3s";
        document.querySelector(".all-cases .inner").style.transitionDelay =
          "0s";
      }, 0);
    } else {
      setActive(true);
      setIsOverflow(!isOverflow);

      // Adding transition delays when adding 'active'
      setTimeout(() => {
        document.querySelector(".all-cases.active").style.transitionDelay =
          "0s";
        document.querySelector(
          ".all-cases.active .layer"
        ).style.transitionDelay = "0.2s";
        document.querySelector(
          ".all-cases.active .inner"
        ).style.transitionDelay = "0.7s";
      }, 0);
    }
  };

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const response = await axios.post(`${baseUrl}get_footer_section`, {
          language: language,
        });
        setFooterData(response.data.Details);
      } catch (error) {
        console.error("Error fetching the Footer Data:", error);
      }
    };
    fetchFooter();
  }, [language]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    mediaType: "",
    sector: "",
    product: "",
    date: "",
    support: "",
    format: "",
    quantity: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const postData = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      company: formData.company,
      email: formData.email,
      phone_no: formData.phone,
      media_type: formData.mediaType,
      sector: formData.sector,
      product: formData.product,
      date: formData.date,
      support: formData.support,
      formate: formData.format,
      quantity: formData.quantity,
      message: formData.message,
    };

    try {
      const response = await axios.post(
        `${baseUrl}ask_for_quotes_section`,
        postData
      );

      setSubmissionStatus("success");
      console.log("Form submitted successfully:", response.data);
      setFormData({
        firstName: "",
        lastName: "",
        company: "",
        email: "",
        phone: "",
        mediaType: "",
        sector: "",
        product: "",
        date: "",
        support: "",
        format: "",
        quantity: "",
        message: "",
        
      });
    } catch (error) {
      setSubmissionStatus("error");
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      setLanguage(Number(savedLanguage));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  const handleLanguage = (e) => {
    e.preventDefault();
    setLanguage(Number(e.target.value));
  };

  return (
    <>
      {/* Header & Banner Section Start */}
      <div>
        <div className="preloader">
          <div className="layer"></div>
          <div className="inner">
            <figure>
              <img src={prelorder} alt="Img" />
            </figure>
            <span>The Art of Contact and the Science of Data</span>
          </div>
        </div>

        <div className={`all-cases ${Active ? "active" : ""}`}>
          <div className="layer"> </div>
          <aside className="left-side left-side2">
            <div className="follow-us">FOLLOW US</div>
            <ul>
              <li>
                <Link to="#">
                  <i className="fab fa-facebook-f"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-twitter"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-linkedin-in"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-google-plus-g"></i>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="fab fa-youtube"></i>
                </Link>
              </li>
            </ul>
            <div className="equalizer">
              <span></span> <span></span> <span></span> <span></span>
            </div>
          </aside>
          <div className="inner">
            <ul>
              <li>
                <NavLink
                  to="/news"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.news}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/agency"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.agency}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/services"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.services}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/work"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.work}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/team"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.team}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  style={({ isActive }) => ({
                    color: isActive ? "#f2cb13" : "transparent",
                    textDecoration: "none",
                    WebkitTextStrokeWidth: isActive ? "0px" : "1px",
                    WebkitTextStrokeColor: isActive ? "transparent" : "#fff",
                  })}
                >
                  {headerTranslations[language]?.contact}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <main>
          <div>
            <div className="main_header">
              <div
                className="completeMenu"
                style={{
                  background: "black",
                }}
              >
                <div className="logo">
                  <Link to="/">
                    <img src={Logo} alt="Img" />
                  </Link>
                </div>
                <div className="all-cases-link">
                  <span className="">
                    <div className="nav-open_main d-flex">
                      <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
                        <NavLink
                          to="/news"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.news}
                        </NavLink>
                        <NavLink
                          to="/agency"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.agency}
                        </NavLink>
                        <NavLink
                          to="/services"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.services}
                        </NavLink>
                        <NavLink
                          to="/work"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.work}
                        </NavLink>
                        <NavLink
                          to="/team"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.team}
                        </NavLink>
                        <NavLink
                          to="/contact"
                          className="nav-link"
                          style={({ isActive }) => ({
                            color: isActive ? "#f2cb13" : "white",
                            textDecoration: "none",
                          })}
                          onClick={() => setMenuOpen(false)}
                        >
                          {headerTranslations[language]?.contact}
                        </NavLink>
                      </nav>
                      <div className="d-flex nav-open_main1">
                        <div className="language-switching">
                          <select value={language} onChange={handleLanguage}>
                            <option value={1}>ENG</option>
                            <option value={2}>FRE</option>
                            <option value={3}>عربي</option>
                          </select>
                        </div>
                        <div className="searching-toggle mx-0">
                          <div
                            className={`search-toggle ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                          >
                            <button
                              className="search-icon icon-search"
                              onClick={toggleSearch}
                            >
                              <i className="fa fa-fw fa-search"></i>
                            </button>
                            <button
                              className="search-icon icon-close"
                              onClick={toggleSearch}
                              style={{
                                display: isSearchOpen ? "inline-block" : "none",
                              }}
                            >
                              <i className="fa fa-fw fa-close"></i>
                            </button>
                          </div>

                          <div
                            className={`search-container d-flex ${
                              isSearchOpen ? "opened" : "closed"
                            }`}
                            style={{ display: isSearchOpen ? "block" : "none" }}
                          >
                            <form onSubmit={handleSearch}>
                              <input
                                type="text"
                                name="q"
                                id="search-terms"
                                placeholder="Search terms..."
                                autoFocus={isSearchOpen}
                              />
                              <button
                                type="submit"
                                name="submit"
                                value="Go"
                                className="search-icon"
                              >
                                <i className="fa fa-fw fa-search"></i>
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                  <b onClick={handleToggleClick}>
                    <i className={`fa ${Active ? "fa-solid" : "fa-bars"}`}></i>
                  </b>
                </div>
              </div>
            </div>
            <aside className="left-side">
              <div className="follow-us">FOLLOW US</div>
              <ul>
                <li>
                  <Link to="#">
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-google-plus-g"></i>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <i className="fab fa-youtube"></i>
                  </Link>
                </li>
              </ul>
              <div className="equalizer">
                <span></span> <span></span> <span></span> <span></span>
              </div>
            </aside>
            <div
              className={`body-content ${isOverflow ? "overflow" : ""}`}
            ></div>
          </div>

          <header className="sliderImg">
            <div className="swiper-container gallery-top">
              <div className="BannerImg">
                <img src={QuotesBanner} alt="BannerImage" />
              </div>
            </div>
            <div className="swiper-container gallery-thumbs">
              <Swiper
                spaceBetween={0}
                slidesPerView={3}
                autoplay={{
                  delay: 9900,
                  disableOnInteraction: false,
                }}
                freeMode
                watchSlidesProgress
                centeredSlides={true}
                touchRatio={0.2}
                slideToClickedSlide={true}
                loop={true}
                loopedSlides={3}
                modules={[Autoplay]}
                breakpoints={{
                  1024: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 1,
                  },
                  640: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                }}
                className="swiper-wrapper"
              >
                <SwiperSlide className="swiper-slide">
                  <p>{headerTranslations[language]?.quotes}</p>
                </SwiperSlide>
              </Swiper>
            </div>
          </header>
        </main>
      </div>
      {/* Header & Banner Section End */}
      <div className="about_quotes">
        <div className="aboutQuotes_heading">
          <h1>{headerTranslations[language]?.quotes}</h1>
          <p>{headerTranslations[language]?.quotestext}</p>
        </div>
        <div className="quote-form-container">
          <form onSubmit={handleSubmit} className="quote-form">
            <div className="row justify-content-center">
              <div className="form-row mt-4">
                <label className="form-label text-dark-gray mb-0 fw-600">
                  {headerTranslations[language]?.enterfirstname}
                </label>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name*"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enterlastname}
                </label>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name*"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
              </div>
              <div className="form-row mt-4">
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.entercompanyname}
                </label>
                <input
                  type="text"
                  name="company"
                  placeholder="Company*"
                  value={formData.company}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enteremailname}
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="E-mail*"
                  value={formData.email}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
              </div>
              <div className="form-row mt-2">
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enterphonenumber}
                </label>
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone*"
                  value={formData.phone}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.entermediatype}
                </label>
                <select
                  name="mediaType"
                  value={formData.mediaType}
                  onChange={handleChange}
                  className="mb-3"
                  required
                >
                  <option value="">Media Type*</option>
                  <option value="tv">TV</option>
                  <option value="radio">Radio</option>
                  <option value="online">Online</option>
                </select>
              </div>
              <div className="form-row mt-2">
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.entersector}
                </label>
                <input
                  type="text"
                  name="sector"
                  placeholder="Sector*"
                  value={formData.sector}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enterproduct}
                </label>
                <input
                  type="text"
                  name="product"
                  placeholder="Product*"
                  value={formData.product}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
              </div>
              <div className="form-row mt-2">
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enterdate}
                </label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.entersupport}
                </label>
                <input
                  type="text"
                  name="support"
                  placeholder="Support*"
                  value={formData.support}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
              </div>
              <div className="form-row mt-2">
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enterformat}
                </label>
                <input
                  type="text"
                  name="format"
                  placeholder="Format*"
                  value={formData.format}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.enterquantity}
                </label>
                <input
                  type="number"
                  name="quantity"
                  placeholder="Quantity*"
                  value={formData.quantity}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
              </div>

              <div className="row d-flex col-md-11 form-row-text mt-2">
                <label className="form-label text-dark-gray mb-0">
                  {headerTranslations[language]?.entermessage}
                </label>
                <textarea
                  name="message"
                  placeholder="Message*"
                  value={formData.message}
                  onChange={handleChange}
                  className="mb-3"
                  required
                />
              </div>
              <button
                type="submit"
                className="row d-flex col-md-11 form-row-text mt-2 quotesButton"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send"}
              </button>
            </div>
          </form>
          {submissionStatus === "success" && (
            <p className="success-message">Quote submitted successfully!</p>
          )}
          {submissionStatus === "error" && (
            <p className="error-message">
              Failed to submit the quote. Please try again.
            </p>
          )}
        </div>
      </div>
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="logoFooter_content">
                <div className="footer_logo">
                  <img src={Logo} alt="footer logo" />
                </div>
                <div className="footer_content">
                  {footerData ? (
                    <p
                      dangerouslySetInnerHTML={{
                        __html: footerData.description
                          .replace(/\r\n/g, "<br/>")
                          .replace(/\n/g, "<br/>"),
                      }}
                    />
                  ) : (
                    <p>Loading Api Data...</p>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="navigation-footer">
                <h4>{headerTranslations[language]?.ourservices}</h4>
                <ul>
                  <li>
                    <Link to="/news">{headerTranslations[language]?.news}</Link>
                  </li>
                  <li>
                    <Link to="/agency">
                      {headerTranslations[language]?.agency}
                    </Link>
                  </li>
                  <li>
                    <Link to="/service">
                      {headerTranslations[language]?.services}
                    </Link>
                  </li>
                  <li>
                    <Link to="/work">{headerTranslations[language]?.work}</Link>
                  </li>
                  <li>
                    <Link to="/team">{headerTranslations[language]?.team}</Link>
                  </li>
                  <li>
                    <Link to="/contact"></Link>
                    {headerTranslations[language]?.contact}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="footerContact_info">
                <h4>{headerTranslations[language]?.contact}</h4>
              </div>
              <div className="footerContact_data">
                <ul>
                  <li>{headerTranslations[language]?.contact}:- +9645689866</li>
                  <li>
                    {headerTranslations[language]?.email}:- info@medialgeria.com
                  </li>
                  <li>
                    {headerTranslations[language]?.address}:- 16122 Collins
                    Street, Melbourne, Australia
                  </li>
                </ul>
              </div>
              {/* <Link to="/contact" className="link">
                Get in touch
              </Link> */}
              <ul className="my-4 social">
                <li>
                  <Link
                    to="https://www.facebook.com/medialgeria/"
                    target="_blank"
                  >
                    <FaFacebookF />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaTwitter />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFLIm8hcMZygAAAAZG8qETwur3Uzvotg1uL5nQzzNIUTZR-X5fqW-nzhAu8LcBV1Tt4KamACgeaXdCmL3ypUUsKR0tNO1jdyL5JW5y05ftYOC8Mc2XWQdSaAlhRGzFdQTLhbEw=&original_referer=&sessionRedirect=https%3A%2F%2Ffr.linkedin.com%2Fcompany%2Fmedialgeria"
                    target="_blank"
                  >
                    <FaLinkedinIn />
                  </Link>
                </li>
                <li>
                  <Link href="#" target="_blank">
                    <FaGooglePlusG />
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.youtube.com/channel/UCDjQDI9xZ_qh2AW8ohoZRjw"
                    target="_blank"
                  >
                    <FaYoutube />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-12">
              <div className="footer-bar">
                <span className="copyright">
                  © 2024 Medialgeria | All Rights Reserved
                </span>
                <span className="creation">
                  Site created by
                  <Link to="https://www.webnmobappssolutions.com/">
                    webnmobapps solutions Pvt. Ltd
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default QuoteForm;
